import type { OtherVideo } from '../types.ts/story';

/**
 * Extracts the editor name from a video's lastActionJson.
 * Returns undefined if no editor info is available.
 */
export function getLastActionEditor(video: OtherVideo): string | undefined {
  return video.lastActionJson?.editor || undefined;
}

/**
 * Extracts the timestamp (as epoch ms) from a video's lastActionJson.
 * Returns 0 if no date info is available.
 */
export function getLastActionTimestamp(video: OtherVideo): number {
  const date = video.lastActionJson?.date;
  if (date == null) return 0;
  return typeof date === 'number' ? date : new Date(date).getTime();
}
